import { setShippingOption } from '../../Actions/Checkout.action';
import CheckoutWidget from './CheckoutWidget';
import { connect } from 'react-redux';

class KlarnaCheckout extends CheckoutWidget {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
    setTimeout(() => this.eventBinding(), 1000);
  }

  eventBinding() {
    window._klarnaCheckout &&
      window._klarnaCheckout((api) => {
        api.on({
          shipping_option_change: (data) => {
            this.props.setSelectedOption(data);
          },
          load: (data) => {
            this.props.setSelectedOption(data.shipping_option_change);
          },
        });
      });
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedOption: (data) => dispatch(setShippingOption(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(KlarnaCheckout);
